import React from 'react';
import {StyleSheet, View, Text, Image, ImageSourcePropType} from 'react-native';
import {colors} from 'src/assets';
import {Icon} from 'src/components';
import {UserStatus} from 'src/domains';
import {VerificationCheckIcon} from '../verification-check-icon';
import {trim} from 'src/utils/string';

type Props = {
  source?: ImageSourcePropType;
  status?: UserStatus;
  name: string;
  isVerified?: boolean;
};

export const User: React.FC<Props> = ({source, status, name, isVerified}) => {
  const avatarStyle = {
    borderRadius: 27,
    borderWidth: 1,
    ...(status === UserStatus.LOGOUT
      ? {
          borderColor: colors.chokuGray6,
        }
      : {}),
    ...(status === UserStatus.OFFERABLE
      ? {
          borderColor: colors.chokuGreen,
        }
      : {}),
    ...(status === UserStatus.ACTIVE
      ? {
          borderColor: colors.orange,
        }
      : {}),
    ...(status === UserStatus.IN_CALL
      ? {
          borderColor: colors.chokuRed,
        }
      : {}),
  };
  return (
    <View style={styles.container}>
      {source ? (
        <Image style={[styles.image, avatarStyle]} source={source} />
      ) : (
        <View style={[styles.imageEmpty, avatarStyle]}>
          <Icon name={'person'} color={colors.chokuGray5} size={24} />
        </View>
      )}
      <View style={{flex: 1, flexDirection: 'row'}}>
        {isVerified !== undefined && (
          <VerificationCheckIcon
            style={{marginLeft: 8}}
            color={isVerified ? colors.chokuRed : '#E3E3E3'}
          />
        )}
        <View style={{flex: 1}}>
          <Text style={styles.text}>{trim(name || '', 32, '...')}さん </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  image: {
    width: 54,
    height: 54,
  },
  imageEmpty: {
    backgroundColor: colors.gray1,
    width: 54,
    height: 54,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '600',
    color: colors.chokuGray5,
  },
});
